import {Button, Col, FloatingLabel, Form, Offcanvas, Row, Spinner} from 'react-bootstrap'
import {FormPersonalLead} from './FormPersonalLead'
import {useEffect, useMemo, useRef, useState} from 'react'
import {DateInput} from '../../../components/DateInput'
import {PhoneInput} from '../../../components/PhoneInput'
import {FormComercialLead} from './FormComercialLead'
import {useMutation, useQuery} from '@apollo/client'
import {GET_CAMPUS_FILTER} from '../../../gql/queries/campusQuery'
import {GET_ALL_LEAD_SOURCE_CATEGORIES} from '../../../gql/queries/leadSourceQuery'
import {GET_ALL_USERS_LIST} from '../../../gql/queries/usersQuery'
import {GET_TAGS_FILTER} from '../../../gql/queries/tagsQuery'
import {toast} from 'react-toastify'
import {IResPipelines} from '../../../types/pipelines'
import {IResTags} from '../../../types/tags'
import {IResAllListUsers} from '../../../types/users'
import {IResCampus} from '../../../types/campus'
import {IResCatLeadSource} from '../../leadSource/leadSourceTypes'
import Select, {MultiValue} from 'react-select'
import {ILeadData, IResCreateLead} from '../leadTypes'
import {parseId} from '../../../helpers'
import {CREATE_LEAD} from '../../../gql/mutations/leadMutations'
import {useGetUser} from '../../../store/userStore'
import moment from 'moment'

interface IDrawerProps {
  isOpen: boolean
  onClose: () => void
  updateListLeads: () => void
  initialPipelineId?: number | string
  dataPipelines?: IResPipelines
}

export const DrawerAddLead = ({
  isOpen,
  onClose,
  updateListLeads,
  initialPipelineId,
  dataPipelines,
}: IDrawerProps) => {
  const [gqlCreate, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IResCreateLead>(CREATE_LEAD)
  const {
    data: dataCampus,
    error: errorCampus,
    loading: loadingCampus,
  } = useQuery<IResCampus>(GET_CAMPUS_FILTER, {fetchPolicy: 'cache-first'})
  const {
    data: dataLeadSource,
    error: errorLeadSource,
    loading: loadingLeadSource,
  } = useQuery<IResCatLeadSource>(GET_ALL_LEAD_SOURCE_CATEGORIES, {fetchPolicy: 'cache-first'})
  const {
    data: dataMembers,
    error: errorMembers,
    loading: loadingMembers,
  } = useQuery<IResAllListUsers>(GET_ALL_USERS_LIST, {fetchPolicy: 'cache-first'})
  const {
    data: dataTags,
    error: errorTags,
    loading: loadingTags,
  } = useQuery<IResTags>(GET_TAGS_FILTER, {fetchPolicy: 'cache-first'})

  const [leadType, setLeadType] = useState<'PERSONAL' | 'COMERCIAL'>('PERSONAL')
  const [valuePipelines, setValuePipelines] = useState('')
  const [stageValue, setStageValue] = useState('')
  const [birthDay, setBirthDay] = useState<string>('')
  const appliedInitialPipelineRef = useRef(false)

  const [valueTags, setValueTags] = useState<
    MultiValue<{
      value: string
      label: string
      color: string
    }>
  >([])
  const [valueMembers, setValueMembers] = useState<
    MultiValue<{
      value: string
      label: string
    }>
  >([])

  useEffect(() => {
    if (errorCampus) toast.error(`Error: ${errorCampus.message}`)
  }, [errorCampus])
  useEffect(() => {
    if (errorLeadSource) toast.error(`Error: ${errorLeadSource.message}`)
  }, [errorLeadSource])
  useEffect(() => {
    if (errorMembers) toast.error(`Error: ${errorMembers.message}`)
  }, [errorMembers])
  useEffect(() => {
    if (errorTags) toast.error(`Error: ${errorTags.message}`)
  }, [errorTags])

  useEffect(() => {
    if (errorCreate) toast.error(`Error: ${errorCreate.message}`)
  }, [errorCreate])

  const userOrganizationId = useGetUser((s) => {
    const orgId = s.user?.user?.organization?.id
    return orgId ? parseId(orgId) : null
  })
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const isSuperAdmin = userGroups.includes('SuperAdministrador')

  const pipelinesFiltered = useMemo(
    () =>
      dataPipelines?.allPipelines?.edges?.filter(({node}) => {
        if (isSuperAdmin) return true
        if (!userOrganizationId) return false
        return node.organization && parseId(node.organization.id) === userOrganizationId
      }) || [],
    [dataPipelines?.allPipelines?.edges, isSuperAdmin, userOrganizationId]
  )

  useEffect(() => {
    if (!isOpen) {
      appliedInitialPipelineRef.current = false
      return
    }
    if (appliedInitialPipelineRef.current) return
    if (!initialPipelineId) {
      setValuePipelines('')
      setStageValue('')
      appliedInitialPipelineRef.current = true
      return
    }
    if (pipelinesFiltered.length === 0) return
    const initialPipelineParsed = parseId(initialPipelineId)
    const pipelineMatch = pipelinesFiltered.find(
      ({node}) => String(parseId(node.id)) === String(initialPipelineParsed)
    )
    if (!pipelineMatch) {
      setValuePipelines('')
      setStageValue('')
      appliedInitialPipelineRef.current = true
      return
    }
    const pipelineId = parseId(pipelineMatch.node.id)
    setValuePipelines(String(pipelineId))
    const stages = pipelineMatch.node.stagePipelineSet?.edges || []
    const firstStage =
      stages.find((edge) => edge.node?.order === 1)?.node ||
      [...stages]
        .sort((a, b) => (a.node.order ?? 0) - (b.node.order ?? 0))
        .find((edge) => edge.node?.id)?.node
    setStageValue(firstStage?.id ? String(parseId(firstStage.id)) : '')
    appliedInitialPipelineRef.current = true
  }, [initialPipelineId, pipelinesFiltered, isOpen])

  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.createLead?.lead?.id) {
      toast.success('Lead created successfully')
      onClose()
      updateListLeads()
    } else if (dataCreate.createLead.errors) {
      toast.error(`Error: ${dataCreate.createLead.errors?.[0]?.message || 'something happened'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {
      name,
      email,
      phone,
      leadSource,
      pipeline,
      campus,
      tags,
      observations,
      stagePipeline,
      ...rest
    } = Object.fromEntries(new FormData(e.currentTarget))
    const leadData: ILeadData = {
      name,
      email,
      phone,
      typeLead: leadType,
      leadSource,
      pipeline,
      campus,
      tags,
      observations,
      stagePipeline,
    }
    if (valueTags.length > 0) {
      leadData.tagInsurance = valueTags.map(({value}) => parseId(value))
    }
    if (valueMembers.length > 0) {
      leadData.user = valueMembers.map(({value}) => parseId(value))
    }
    if (leadType === 'PERSONAL') {
      leadData.personalLead = {...rest}
      if (!leadData.personalLead.birthDay) {
        delete leadData.personalLead.birthDay
      }
    }
    if (leadType === 'COMERCIAL') {
      leadData.comercialLead = {...rest}
    }
    delete leadData.tags
    delete leadData.pipeline
    gqlCreate({
      variables: {
        leadData,
      },
    })
  }

  const isLoading =
    loadingCampus ||
    !dataCampus ||
    loadingLeadSource ||
    !dataLeadSource ||
    loadingMembers ||
    !dataMembers ||
    !dataPipelines ||
    loadingTags ||
    !dataTags

  if (isLoading) {
    return (
      <Offcanvas show={isOpen} onHide={onClose} placement='end' className='w-100 w-md-75 w-lg-75'>
        <Offcanvas.Header closeButton className='bg-light'>
          <div className='d-flex align-items-center justify-content-between w-100'>
            <Offcanvas.Title className='d-flex align-items-center gap-4'>Add Lead</Offcanvas.Title>
            <div className='d-flex align-items-center gap-1'>
              <button
                className=''
                onClick={() => {
                  setLeadType('PERSONAL')
                }}
                style={{
                  border: 'none',
                  padding: '4px 10px',
                  borderRadius: '14px',
                  color: leadType === 'PERSONAL' ? 'white' : 'gray',
                  backgroundColor: leadType === 'PERSONAL' ? '#3e97ff' : '#e4e4e4',
                }}
              >
                Personal
              </button>
              <button
                className=''
                onClick={() => {
                  setLeadType('COMERCIAL')
                }}
                style={{
                  border: 'none',
                  padding: '4px 10px',
                  borderRadius: '14px',
                  color: leadType === 'COMERCIAL' ? 'white' : 'gray',
                  backgroundColor: leadType === 'COMERCIAL' ? '#3e97ff' : '#e4e4e4',
                }}
              >
                Commercial
              </button>
            </div>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className='d-flex p-6 h-100'>
            <Spinner animation='border' />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    )
  }

  return (
    <Offcanvas show={isOpen} onHide={onClose} placement='end' className='w-100 w-md-75 w-lg-75'>
      <Offcanvas.Header closeButton className='bg-light'>
        <div className='d-flex align-items-center justify-content-between w-100'>
          <Offcanvas.Title className='d-flex align-items-center gap-4'>Add Lead</Offcanvas.Title>
          <div className='d-flex align-items-center gap-1'>
            <button
              className=''
              onClick={() => {
                setLeadType('PERSONAL')
              }}
              style={{
                border: 'none',
                padding: '4px 10px',
                borderRadius: '14px',
                color: leadType === 'PERSONAL' ? 'white' : 'gray',
                backgroundColor: leadType === 'PERSONAL' ? '#3e97ff' : '#e4e4e4',
              }}
            >
              Personal
            </button>
            <button
              className=''
              onClick={() => {
                setLeadType('COMERCIAL')
              }}
              style={{
                border: 'none',
                padding: '4px 10px',
                borderRadius: '14px',
                color: leadType === 'COMERCIAL' ? 'white' : 'gray',
                backgroundColor: leadType === 'COMERCIAL' ? '#3e97ff' : '#e4e4e4',
              }}
            >
              Commercial
            </button>
          </div>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={handleSubmit}>
          <div className='lead-summary-layout'>
            <div className='lead-summary lead-summary-sticky'>
              <div className='kt-heading kt-heading--sm custom-border-brand my-3'>Lead Summary</div>
              <Form.Group className='mb-3'>
                <Form.Label>
                  Pipeline <span style={{color: 'red'}}>*</span>
                </Form.Label>
                <Form.Select
                  aria-label='Pipeline'
                  name='pipeline'
                  required
                  size='sm'
                  value={valuePipelines}
                  onChange={(e) => {
                    const nextPipeline = e.target.value
                    setValuePipelines(nextPipeline)
                    const pipeline = pipelinesFiltered.find(
                      ({node}) => String(parseId(node.id)) === String(nextPipeline)
                    )
                    const stages = pipeline?.node.stagePipelineSet?.edges || []
                    const firstStage =
                      stages.find((edge) => edge.node?.order === 1)?.node ||
                      [...stages]
                        .sort((a, b) => (a.node.order ?? 0) - (b.node.order ?? 0))
                        .find((edge) => edge.node?.id)?.node
                    if (firstStage?.id) {
                      setStageValue(String(parseId(firstStage.id)))
                    } else {
                      setStageValue('')
                    }
                  }}
                >
                  <option value=''>Nothing selected</option>
                  {pipelinesFiltered.map(({node}) => (
                    <option value={parseId(node.id)} key={node.id}>
                      {node.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>
                  Stage <span style={{color: 'red'}}>*</span>
                </Form.Label>
                <Form.Select
                  aria-label='stagePipeline'
                  name='stagePipeline'
                  required
                  size='sm'
                  value={stageValue}
                  onChange={(e) => setStageValue(e.target.value)}
                >
                  <option value=''>Nothing selected</option>
                  {[...(pipelinesFiltered.find(
                    ({node}) => String(parseId(node.id)) === String(valuePipelines)
                  )?.node.stagePipelineSet.edges || [])]
                    .sort((a, b) => (a.node.order ?? 0) - (b.node.order ?? 0))
                    .map(({node}) => (
                      <option key={node.id} value={parseId(node.id)}>
                        {node.name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>
                  Lead source <span style={{color: 'red'}}>*</span>
                </Form.Label>
                <Form.Select aria-label='Lead source' name='leadSource' required size='sm'>
                  <option value=''>Please select</option>
                  {dataLeadSource.allCategoryLeadSource.edges.map(({node}) => (
                    <optgroup label={node.name} key={node.id}>
                      {node.leadSourceSet.edges.map(({node: nodeLead}) => (
                        <option key={nodeLead.id} value={parseId(nodeLead.id)}>
                          {nodeLead.name}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-3 z-999'>
                <Form.Label>
                  Tags <span style={{color: 'red'}}>*</span>
                </Form.Label>
                <Select
                  classNames={{
                    control: () => 'h-100',
                    container: () => 'h-100',
                  }}
                  placeholder='Select tags'
                  id='tags-cont'
                  required
                  inputId='tags'
                  name='tags'
                  options={dataTags.allTagInsurances.edges.map(({node}) => ({
                    value: node.id,
                    label: node.name,
                    color: node.color,
                  }))}
                  isMulti
                  value={valueTags}
                  onChange={(e) => {
                    setValueTags(e)
                  }}
                  styles={{
                    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
                      const color = data.color
                      return {
                        ...styles,
                        zIndex: 9999,
                        backgroundColor: isDisabled
                          ? undefined
                          : isSelected
                          ? data.color
                          : isFocused
                          ? color
                          : undefined,
                        color: isDisabled ? '#c0c0c0' : isSelected ? 'white' : '#5b5b5b',
                        cursor: isDisabled ? 'not-allowed' : 'default',
                        ':active': {
                          ...styles[':active'],
                          backgroundColor: !isDisabled
                            ? isSelected
                              ? data.color
                              : color
                            : undefined,
                        },
                      }
                    },
                    multiValue: (styles, {data}) => {
                      const color = data.color
                      return {
                        ...styles,
                        backgroundColor: color,
                      }
                    },
                    multiValueLabel: (styles) => ({
                      ...styles,
                      color: 'white',
                    }),
                    multiValueRemove: (styles, {data}) => ({
                      ...styles,
                      color: 'white',
                      ':hover': {
                        backgroundColor: data.color,
                        color: 'white',
                      },
                    }),
                    control: (styles, {isDisabled, isFocused}) => {
                      return {
                        ...styles,
                        minHeight: '36px',
                        border: isDisabled
                          ? '1px solid #ccc'
                          : isFocused
                          ? '1px solid white'
                          : '1px solid #dbdfe9',
                        cursor: isDisabled ? 'not-allowed' : 'default',
                      }
                    },
                    singleValue: (styles) => ({
                      ...styles,
                      color: '#1f2937',
                    }),
                  }}
                />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>
                  Location <span style={{color: 'red'}}>*</span>
                </Form.Label>
                <Form.Select aria-label='Location' name='campus' required size='sm'>
                  {dataCampus.allCampus.edges.map(({node}) => (
                    <option value={parseId(node.id)} key={node.id}>
                      {node.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-3 z-999'>
                <Form.Label>Assigned to</Form.Label>
                <Select
                  classNames={{
                    container: () => 'h-100',
                  }}
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      minHeight: '36px',
                    }),
                    option: (styles, {isDisabled, isSelected, isFocused}) => ({
                      ...styles,
                      backgroundColor: isSelected ? '#4b4fd1' : isFocused ? '#eef2ff' : undefined,
                      color: isDisabled ? '#c0c0c0' : isSelected ? 'white' : '#5b5b5b',
                      cursor: isDisabled ? 'not-allowed' : 'default',
                    }),
                    singleValue: (styles) => ({
                      ...styles,
                      color: '#1f2937',
                    }),
                  }}
                  placeholder='Select members'
                  options={dataMembers?.allUsersList.map((node) => ({
                    value: node.id,
                    label: `${node.firstName} ${node.lastName}`,
                  }))}
                  isMulti
                  value={valueMembers}
                  onChange={(e) => {
                    setValueMembers(e)
                  }}
                />
              </Form.Group>
            </div>
            <div className='lead-summary-content'>
              <Row>
                {/* Personal Information | Address Information */}
                <Col className='col-lg-8 col-md-8 col-12 holder-division'>
                  <div className='kt-heading kt-heading--md custom-border-brand mb-3'>Personal Information</div>
                  <Row>
                    <Col className='col-12 mb-4'>
                      <Form.Group>
                        <Form.Label>
                          Lead Name <span style={{color: 'red'}}>*</span>
                        </Form.Label>
                        <Form.Control placeholder='Lead Name' name='name' required />
                      </Form.Group>
                    </Col>
                    {leadType === 'PERSONAL' && (
                      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                        <DateInput
                          id='birthDay'
                          name='birthDay'
                          label={
                            <>
                              <span>Date of Birth</span>
                              <span className='age'>
                                {birthDay
                                  ? `Age: ${moment().diff(moment(birthDay), 'years')}`
                                  : 'Age: -'}
                              </span>
                            </>
                          }
                          labelClassName='label-date-of-birth-age d-flex justify-content-between align-items-center w-100'
                          placeholder='Date of Birth'
                          value={birthDay}
                          onChange={(_, value) => setBirthDay(value || '')}
                        />
                        <input type='hidden' name='birthDay' value={birthDay} />
                      </Col>
                    )}
                    {leadType === 'PERSONAL' && (
                      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                        <Form.Group>
                          <Form.Label>Civil Status</Form.Label>
                          <Form.Control
                            name='civilStatus'
                            type='text'
                            placeholder='Civil Status'
                          />
                        </Form.Group>
                      </Col>
                    )}
                    <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                      <Form.Group>
                        <Form.Label>
                          Email <span style={{color: 'red'}}>*</span>
                        </Form.Label>
                        <Form.Control placeholder='Email' name='email' required />
                      </Form.Group>
                    </Col>
                    <Col className='col-lg-6 col-md-6 col-12 mb-4'>
                      <Form.Group>
                        <PhoneInput
                          id='phone'
                          name='phone'
                          label={
                            <span>
                              Phone <span style={{color: 'red'}}>*</span>
                            </span>
                          }
                          value=''
                          onChange={() => {}}
                        />
                      </Form.Group>
                    </Col>

                    <Col className='col-12 mb-4'>
                      <FloatingLabel controlId='observations' label='Observations'>
                        <Form.Control
                          name='observations'
                          as='textarea'
                          rows={4}
                          placeholder='Observations'
                          className='h-100'
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Col>

                {leadType === 'PERSONAL' && (
                  <Col className='col-lg-4 col-md-4 col-12'>
                    <div className='kt-heading kt-heading--md custom-border-brand mb-3'>Address Information</div>
                    <FormPersonalLead />
                  </Col>
                )}
                {leadType === 'COMERCIAL' && <FormComercialLead />}
              </Row>

              <div
                className='d-flex align-items-center justify-content-start gap-2 mt-8 pt-3 pb-8'
                style={{borderTop: '1px solid #f1f1f1'}}
              >
                <Button type='button' variant='light' onClick={onClose}>
                  Cancel
                </Button>
                <Button type='submit' disabled={loadingCreate}>
                  {loadingCreate && <Spinner animation='border' size='sm' />}
                  Create
                </Button>
              </div>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  )
}
